/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteScheduledSurveyMutationVariables = Types.Exact<{
  surveyId: Types.Scalars['Int'];
}>;


export type DeleteScheduledSurveyMutation = { deleteScheduledSurvey: boolean };


export const DeleteScheduledSurveyDocument = gql`
    mutation DeleteScheduledSurvey($surveyId: Int!) {
  deleteScheduledSurvey(id: $surveyId)
}
    `;

/**
 * __useDeleteScheduledSurveyMutation__
 *
 * To run a mutation, you first call `useDeleteScheduledSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScheduledSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScheduledSurveyMutation, { data, loading, error }] = useDeleteScheduledSurveyMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useDeleteScheduledSurveyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteScheduledSurveyMutation, DeleteScheduledSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteScheduledSurveyMutation, DeleteScheduledSurveyMutationVariables>(DeleteScheduledSurveyDocument, options);
      }
export type DeleteScheduledSurveyMutationHookResult = ReturnType<typeof useDeleteScheduledSurveyMutation>;
export type DeleteScheduledSurveyMutationResult = Apollo.MutationResult<DeleteScheduledSurveyMutation>;
export type DeleteScheduledSurveyMutationOptions = Apollo.BaseMutationOptions<DeleteScheduledSurveyMutation, DeleteScheduledSurveyMutationVariables>;